import React from 'react';
import { Block } from '../../types';

interface BlockActionsProps {
  block: Block;
  onDelete: () => void;
}

export const BlockActionsComponent: React.FC<BlockActionsProps> = ({
  block,
  onDelete,
}) => {
  return (
    <div className="flex items-center justify-center space-x-1">
      {/* Bouton de suppression - toujours visible */}
      <button
        onClick={onDelete}
        className="p-1 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded transition-all duration-200 hover:scale-110 group"
        title="Supprimer"
        tabIndex={0}
      >
        {/* Croix rouge personnalisée */}
        <svg 
          className="w-4 h-4 transition-all duration-200 group-hover:rotate-90" 
          fill="currentColor" 
          viewBox="0 0 20 20"
        >
          <path 
            fillRule="evenodd" 
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" 
            clipRule="evenodd" 
          />
        </svg>
      </button>
    </div>
  );
};
